import { render, staticRenderFns } from "./professionalControl.vue?vue&type=template&id=5649ec83&scoped=true&"
import script from "./professionalControl.vue?vue&type=script&lang=js&"
export * from "./professionalControl.vue?vue&type=script&lang=js&"
import style0 from "./professionalControl.vue?vue&type=style&index=0&id=5649ec83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5649ec83",
  null
  
)

export default component.exports